module.exports = __webpack_public_path__ + "img/cm_s6-desc.28825847.png";